import React from 'react';
import Split from '../../../../split';
import { Box, Typography } from '@mui/material';

const SubHeader = ({ header, variant = 'overline', props, containerProps, ...rest }) => {
    const { split, ...restProps } = props;

    const shouldRender = Split.getBooleanTreatment(split);
    if (!!split && !shouldRender) {
        return null;
    }

    return (
        <Box {...containerProps}>
            <Typography variant={variant} {...restProps}>
                {header}
            </Typography>
        </Box>
    );
};

export default SubHeader;
